import { mutatorAction } from 'satcheljs';
import { type MailboxInfo } from 'owa-client-types';
import { getAsyncItemRegistry } from '../selectors/getAsyncItemRegistry';

/**
 * Empties an account's registry (entries only; keeps `seedStatus`). Primarily a seeding helper for
 * Storybook / test scenarios that need a clean slate between renders.
 */
export const clearAsyncItemRegistryMutator: (mailboxInfo: MailboxInfo) => void = mutatorAction(
    'clearAsyncItemRegistryMutator',
    (mailboxInfo: MailboxInfo) => {
        getAsyncItemRegistry(mailboxInfo)?.entriesById.clear();
    }
);
